<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="auth.profile.title"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="auth.profile.title"></app-i18n>
      </h1>

      <el-form
        :label-position="labelPosition"
        :label-width="labelWidthForm"
        :model="model"
        :rules="rules"
        @submit.native.prevent="doSubmit"
        class="form"
        ref="form"
      >
        <el-row :gutter="10">
          <!-- First Name -->
          <el-col :lg="11" :md="16" :sm="24">
            <el-form-item
              :label="fields.firstName.label"
              :prop="fields.firstName.name"
              :required="fields.firstName.required"
            >
              <el-input 
                v-model="model[fields.firstName.name]"
                :placeholder="i18n('user.placeholders.firstName')"
                prefix-icon="icon-player"
              />
            </el-form-item>
          </el-col>

          <!-- Last Name -->
          <el-col :lg="11" :md="16" :sm="24">
            <el-form-item
              :label="fields.lastName.label"
              :prop="fields.lastName.name"
              :required="fields.lastName.required"
            >
              <el-input 
                v-model="model[fields.lastName.name]"
                :placeholder="i18n('user.placeholders.lastName')"
                prefix-icon="icon-player"
              />
            </el-form-item>
          </el-col>

          <!-- Gender -->
          <el-col :lg="11" :md="16" :sm="24">
            <el-form-item
              :label="fields.gender.label"
              :prop="fields.gender.name"
              :required="fields.gender.required"
            >
              <el-select
                :placeholder="i18n('user.placeholders.gender')"
                v-model="model[fields.gender.name]"
              >
                <i
                  slot="prefix"
                  class="icon-family"
                />
                <el-option
                  :key="option.id"
                  :label="option.label"
                  :value="option.id"
                  v-for="option in fields.gender.options"
                />
              </el-select>
            </el-form-item>
          </el-col>
          
          <!-- Birthdate -->
          <el-col :lg="11" :md="16" :sm="24">
            <el-form-item
              :label="fields.birthdate.label"
              :prop="fields.birthdate.name"
              :required="fields.birthdate.required"
            >
              <el-date-picker
                type="date"
                :placeholder="i18n('common.date.formatInput')"
                :format="i18n('common.date.formatInput')"
                v-model="model[fields.birthdate.name]"
              ></el-date-picker>
            </el-form-item>
          </el-col>

          <!-- Phone Number -->
          <el-col :lg="11" :md="16" :sm="24">
            <el-form-item
              :label="fields.phoneNumber.label"
              :prop="fields.phoneNumber.name"
              :required="fields.phoneNumber.required"
            >
              <phone-input v-model="model[fields.phoneNumber.name]" />
            </el-form-item>
          </el-col>

          <!-- Avatar Profile -->
          <el-col :lg="24" :md="24" :sm="24">
            <el-form-item
              :label="fields.avatarsProfile.label"
              :prop="fields.avatarsProfile.name"
              :required="fields.avatarsProfile.required"
            >
              <app-image-upload
                :max="fields.avatarsProfile.max"
                :path="fields.avatarsProfile.path(currentUser.authenticationUid)"
                :schema="fields.avatarsProfile.fileSchema"
                v-model="model[fields.avatarsProfile.name]"
                :placeholder="i18n('common.uploadFile')"
              ></app-image-upload>
            </el-form-item>
          </el-col>

          <el-col :lg="11" :md="16" :sm="24">
            <el-form-item>
              <div class="form-buttons">
                <el-button
                  :disabled="saveLoading"
                  @click="doSubmit"
                  type="primary"
                >
                  <app-i18n code="common.save"></app-i18n>
                </el-button>

                <!-- <el-button :disabled="saveLoading" @click="doReset" icon="el-icon-fa-undo">
              <app-i18n code="common.reset"></app-i18n>
                </el-button>-->
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import { UserModel } from '@modules/auth/user-model';
import { mapGetters, mapActions } from 'vuex';
import { FormSchema } from '@shared/form/form-schema';
import { i18n } from '@shared/i18n';

export default {
  name: 'app-profile-form-page',

  props: {
    navigateOnSubmit: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      model: null,
    };
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      currentUser: 'auth/currentUser',
      saveLoading: 'auth/loadingUpdateProfile',
      dateFormat: 'auth/manage/dateFormat',
      timeFormat: 'auth/manage/timeFormat',
    }),

    rules() {
      const { formSchema } = this;
      return formSchema.rules();
    },
    
    formSchema() {
      const { fields } = this;
      return new FormSchema([
        fields.firstName,
        fields.lastName,
        fields.gender,
        fields.birthdate,
        fields.phoneNumber,
        fields.avatarsProfile,
      ]);
    },

    fields() {
      const { dateFormat, timeFormat} = this;
      return new UserModel({
        dateFormat, timeFormat
      }).fields();
    },
  },

  async created() {
    const { formSchema } = this;

    this.model = formSchema.initialValues(this.currentUser);
  },

  methods: {
    ...mapActions({
      doUpdateProfile: 'auth/doUpdateProfile',
    }),

    doReset() {
      const { formSchema } = this;
      this.model = formSchema.initialValues(
        this.currentUser,
      );
    },

    async doSubmit() {
      const { formSchema } = this;
      try {
        await this.$refs.form.validate();
      } catch (error) {
        return;
      }

      const values = formSchema.cast(this.model);
      this.doUpdateProfile({
        values,
        navigateOnSubmit: this.navigateOnSubmit,
      });
    },

    i18n(code) {
      return i18n(code);
    },
  },
};
</script>

